import { useEffect, useState } from 'react';
import { useMounted } from 'shared/hooks/utils';
import { useVisibilityChange } from '@uidotdev/usehooks';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
export function isSupportedWakeLock() {
    return 'wakeLock' in navigator;
}
export function useWakeLockElement(active) {
    if (!isSupportedWakeLock()) {
        return;
    }
    const do_start_wake_lock = useAppSelector((state) => select_ui_settings(state).map?.do_not_turn_off_screen) ?? false;
    const is_mounted = useMounted();
    const [wakeLockInstance, setWakeLockInstance] = useState(null);
    const documentVisible = useVisibilityChange();
    useEffect(() => {
        (async () => {
            if (documentVisible) {
                if (active && do_start_wake_lock) {
                    await wakeLockInstance?.release();
                    const inst = await navigator.wakeLock?.request('screen');
                    if (inst == null) {
                        return;
                    }
                    if (inst) {
                        inst.onrelease = (ev) => {
                            if (is_mounted.current) {
                                setWakeLockInstance(null);
                            }
                        };
                        setWakeLockInstance(inst);
                    }
                }
                else {
                    if (is_mounted.current) {
                        await wakeLockInstance?.release();
                        setWakeLockInstance(null);
                    }
                }
            }
        })();
        return () => {
            if (is_mounted.current) {
                wakeLockInstance?.release();
                setWakeLockInstance(null);
            }
        };
    }, [documentVisible]);
}
